import React from 'react';
import { cn } from '../../lib/utils';

const statusConfig = {
  pending: {
    label: 'En attente',
    className: 'status-pending'
  },
  open: {
    label: 'En cours',
    className: 'status-open'
  },
  blocked: {
    label: 'Bloqué',
    className: 'status-blocked'
  },
  resolved: {
    label: 'Résolu',
    className: 'status-resolved'
  },
  closed: {
    label: 'Fermé',
    className: 'status-closed'
  }
};

export const StatusBadge = ({ status, className }) => {
  const config = statusConfig[status] || statusConfig.pending;
  
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border',
        config.className,
        className
      )}
    >
      {config.label}
    </span>
  );
};

export const PriorityBadge = ({ priority, className }) => {
  const priorityConfig = {
    low: { label: 'Basse', className: 'priority-low' },
    normal: { label: 'Normale', className: 'priority-normal' },
    high: { label: 'Haute', className: 'priority-high' },
    urgent: { label: 'Urgente', className: 'priority-urgent pulse-urgent' }
  };
  
  const config = priorityConfig[priority] || priorityConfig.normal;
  
  return (
    <span className={cn('text-xs font-medium', config.className, className)}>
      {config.label}
    </span>
  );
};

export default StatusBadge;
